import React, {Component} from "react";
import { Typography, Grid } from '@material-ui/core';

class TitleText extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    

    render() { 
        const {data} = this.props;
        return (
            <>
                {/* <Typography style={{fontSize: 48, fontFamily: 'MOMCAKE', color: '#1E3163', fontWeight: 700}}>{this.props.title}</Typography>
                <Typography color='textSecondary' style={{fontSize: 18, fontFamily: 'Roboto'}}>{this.props.title}</Typography> */}
                <div className="text-title main-text-color">{this.props.title}</div>
                <div className="text-sub-title sub-title-color">{this.props.subTitle}</div>
            </>
        );
    }
}
 
export default TitleText;